<template>
  <reach-input
      label="EAN"
      :formField="validatedField"
      :read-only="readOnly"
  >
    <template slot="right-slot">
      <b-button style="height: 38px; margin-right: 1px" @click="editEAN" class="input-group-text solid"
                v-if="!readOnly && isVisibleOpenGeneratorEAN">
        <font-awesome-icon icon="pencil-alt"/>
      </b-button>
      <b-button style="height: 38px" @click="openGeneratorEAN" class="input-group-text solid"
                v-if="!readOnly && isVisibleOpenGeneratorEAN" data-test-path="magnifyingEan">
        <font-awesome-icon icon="magnifying-glass-plus"/>
      </b-button>
    </template>

  </reach-input>
</template>

<script>

import InputBase from "@/components/inputs/InputBase";
import ReachInput from "@/components/inputs/ReachInput";
import FormValidatedField from "@/components/forms/FormValidatedField";
import DecimalFormFieldConfig from "@/server/com/silkplm/engine/forms/schema/definition/DecimalFormFieldConfig";
import DialogManager from "@/utils/DialogManager";
import Rpc from "@/Rpc";
import TextFormFieldConfig from "@/server/com/silkplm/engine/forms/schema/definition/TextFormFieldConfig";
import PermissionsSet from "@/server/PermissionsSet";
import FormsLoader from "@/components/forms/FormsLoader";
import EAN from "@/server/com/silkplm/model/plm/EAN";

export default {
  name: "EANRenderer",
  components: {InputBase, ReachInput},
  created() {
  },

  async mounted() {
    let formConfig = this.validatedField.getFormConfig();
    this.isVisibleOpenGeneratorEAN = formConfig.formClassLong === EAN.getRemoteClass();
  },

  props: {
    validatedField: {type: FormValidatedField, required: true},
    fieldConfig: {type: TextFormFieldConfig, required: true},
  },

  methods: {
    setReadOnly(readOnly) {
      this.readOnly = this.fieldConfig.readOnly || readOnly;
    },

    setEditorMode(val) {
      this.editorMode = val;
    },

    async openGeneratorEAN() {
      if (await DialogManager.yesNo($tr('assigningEan','Assigning EAN'), this.message)) {
        await this.assignEAN();
      }
    },

    editEAN() {
      this.readOnly = false;
    },


    async assignEAN() {
      let res = await Rpc.plm.EANGenerator.allocateEAN().lock();
      if (res) {
        this.validatedField.value = res;
      } else {
        await DialogManager.info($tr('eanRenderer.listOfFree.isEmpty','The list of free EAN\'s is empty.'),
            $tr('eanRenderer.listIsEmpty.add','EAN\'s list is empty - add them.'));
      }
    },

  },

  data: () => ({
    readOnly: true,
    editorMode: false,
    isVisibleOpenGeneratorEAN: false,
    message: $tr('eanRenderer.sure.assign.ean','Are you sure you want to assign EAN? <br> Performing this operation will block this number.'),
  })
}

</script>

<style scoped>

</style>